module.exports = __webpack_public_path__ + "media/assets/svg/logos/amazon-connect-4ea8767c7e478fd8c2e2d3431bd6c9d0.svg";